// extracted by mini-css-extract-plugin
module.exports = {"triggers":"TabGroup_triggers___e47e","rotation":"TabGroup_rotation___gJsG"};